"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReEnterInputWrapper = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var FieldHeading_1 = require("../FieldHeading");
var StyledHeading = styled_1.default(FieldHeading_1.FieldHeading)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 4px;\n"], ["\n  margin-bottom: 4px;\n"])));
var ReEnterInputWrapper = function (_a) {
    var color = _a.color, children = _a.children, className = _a.className, name = _a.name, reEnterPropertyId = _a.reEnterPropertyId;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledHeading, { className: className, name: name, color: color, required: false, propertyId: reEnterPropertyId, displayRequiredLabel: false }),
        children));
};
exports.ReEnterInputWrapper = ReEnterInputWrapper;
var templateObject_1;
